/**
 * Returns the path segment after /registry/ when the pathname is for the given
 * org's registry (e.g. /MyOrg/registry/animals/transfers -> "animals/transfers").
 * Returns null if not in registry for that org or if there is no suffix.
 */
export function getRegistryPathSuffix(
  pathname: string,
  currentOrgName: string,
): string | null {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 3) return null;
  const [orgSegment, registrySegment, ...rest] = segments;
  if (orgSegment !== currentOrgName || registrySegment !== 'registry')
    return null;
  const suffix = rest.join('/');
  return suffix.length > 0 ? suffix : null;
}

const KNOWN_MEMBERS_SUB_ROUTES = new Set(['create', 'add-member']);
const KNOWN_ANIMALS_SUB_ROUTES = new Set(['create', 'transfers']);

/**
 * Strips entity-specific dynamic segments (e.g. member/animal IDs) from the
 * registry path suffix so that an org switch redirects to the list page
 * instead of a detail page whose entity belongs to the previous org.
 */
export function sanitizePathSuffixForOrgSwitch(suffix: string): string {
  const parts = suffix.split('/');

  if (
    parts[0] === 'members' &&
    parts.length > 1 &&
    !KNOWN_MEMBERS_SUB_ROUTES.has(parts[1]!)
  ) {
    return 'members';
  }

  if (
    parts[0] === 'animals' &&
    parts.length > 1 &&
    !KNOWN_ANIMALS_SUB_ROUTES.has(parts[1]!)
  ) {
    return 'animals';
  }

  return suffix;
}
